import Vue from 'vue'
//import VueI18n from 'vue-i18n';
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VModal from 'vue-js-modal'
import VueMoment from 'vue-moment'
import { ToastPlugin } from 'bootstrap-vue'
import VueChatScroll from "vue-chat-scroll";
import 'bootstrap-vue/dist/bootstrap-vue.css'
import i18n from "./i18n";

Vue.config.productionTip = false

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  timeout: 60000
});

const token = sessionStorage.getItem('token')
if (token) {
  axiosInstance.defaults.headers.common['Authorization'] = "Bearer " + token
}

Vue.use(VueAxios, axiosInstance)
Vue.use(VueMoment)
Vue.use(VModal, { dialog: true })
Vue.use(ToastPlugin)
Vue.use(VueChatScroll);
//Vue.use(VueI18n);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
